module.exports = __webpack_public_path__ + "img/upload.83bba633.jpg";